import type { SupportedRepubName } from '~/vendor/cx-web/domain-types';

import { AUTH_CONFIGS, type AuthConfig } from './auth-config';
import { ERROR_PAGE_CONFIGS, type ErrorPageConfig } from './ui-config';

/** The slice of the plus config that shared code reads: the myoc-login modal and RootErrorPage. */
export type PlusConfig = {
  auth: AuthConfig;
  errorPage?: ErrorPageConfig;
  name: string;
};

export const PLUS_CONFIGS = {
  WS: {
    auth: AUTH_CONFIGS.WS,
    errorPage: ERROR_PAGE_CONFIGS.WS,
    name: 'WhoScored',
  },
  US: {
    auth: AUTH_CONFIGS.US,
    name: 'Oddschecker',
  },
  OC: {
    auth: AUTH_CONFIGS.OC,
    name: 'Oddschecker',
  },
  GZ: {
    auth: AUTH_CONFIGS.GZ,
    errorPage: ERROR_PAGE_CONFIGS.GZ,
    name: 'Gazzetta',
  },
} satisfies Record<SupportedRepubName, PlusConfig>;
